import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { getLatestStories } from "../../../actions/latestStories";
import MiniStoryCard from "../MiniStoryCard";
import Spinner from "../Spinner";
import styles from "./LatestStories.css";

class LatestStories extends Component {
  componentDidMount() {
    if(!this.props.latestStories.results.length) {
      this.props.getLatestStories();
    }
  }

  render() {
    if (this.props.latestStories.results.length === 0) {
      if (this.props.latestStories.isLoading) {
        return <Spinner />;
      }
      return null;
    }

    const latestSorted = this.props.latestStories.results
      .sort((a, b) => a.published_date > b.published_date ? -1 : a.published_date < b.published_date ? 1 : 0);

    return (
      <div className={this.props.className}>
        <div className={classNames(styles.heading, styles.hiddenLarge)}>Latest Stories</div>
        <div className={styles.root}>
          <div className={classNames(styles.heading, styles.hiddenSmall)}>Newest Stories</div>
          {latestSorted.map((latest, key) => (<MiniStoryCard key={key} latest={latest}/>))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    latestStories: state.latestStories,
  };
};

export default connect(mapStateToProps, { getLatestStories })(LatestStories);



// WEBPACK FOOTER //
// ./src/components/Library/LatestStories/LatestStories.js